import Button from "components/components/Button/Button";
import {
  AppliedFiltersContainer,
  AppliedFilterTag,
  AppliedFilterTagsList,
} from "components/components/Iris/AuthenticatedView/IrisDetailsPage/IrisDetails/QueueInfoCard/QueueFilters/style";
import React from "react";

interface Props {
  appliedFilters: string[];
  onRemoveAllFiltersClick: () => void;
}

export const AppliedFilters: React.FC<Props> = ({
  appliedFilters,
  onRemoveAllFiltersClick,
}) => (
  <AppliedFiltersContainer>
    <AppliedFilterTagsList>
      {appliedFilters.length > 10 ? (
        <p data-test-id="filters-count">
          {appliedFilters.length} filters applied
        </p>
      ) : (
        appliedFilters.map((filterName) => (
          <AppliedFilterTag key={filterName} data-test-id="queue-filter-tag">
            {filterName}
          </AppliedFilterTag>
        ))
      )}
    </AppliedFilterTagsList>
    <div>
      <Button
        className="link-inline"
        buttonText="Remove all filters"
        onClick={onRemoveAllFiltersClick}
        dataTestId="remove-all-filters-button"
      />
    </div>
  </AppliedFiltersContainer>
);
